import './proposedRemuneration.less';

import * as _ from 'lodash';
import { getAttachmentTypeName } from '../../objects/Attachment';
import { claimTypes } from '../../objects/Claim';
import { auditIncidents } from '../../objects/Audit';
import { getRemunerationTitle } from '../../misc/textHelper';
import { remunerationTypes } from '../../objects/Payslip';

/**
 * @typedef { import('./ProposedGroupModel').ProposedGroupModel } ProposedGroupModel
 * @typedef { import('../PaymentLock').PaymentLock } PaymentLock
 * @typedef { import('../../objects/Claim').Claim } Claim
 * @typedef { import('../../server/ApiServer').ApiServer } ApiServer
 */

/**
 * 
 * @param {Claim} claim 
 * @returns 
 */
function getClaimDescription(claim) {
    switch (claim.ClaimType) {
        case claimTypes.legacyTravel:
            if (claim.Nugget.RouteFrom || claim.Nugget.RouteTo) {
                return claim.Nugget.RouteFrom + " till " + claim.Nugget.RouteTo;
            } else {
                let parts = [];
                if (claim.Nugget.Parking) {
                    parts.push('Parkering');
                }
                if (claim.Nugget.Congestion) {
                    parts.push('Trängselskatt');
                }
                if (claim.Nugget.PublicTransport) {
                    parts.push('Kollektivtrafik');
                }
                if (claim.Nugget.TravelTime) {
                    parts.push('Restid');
                }
                return  parts.join(", ");
            }
        case claimTypes.travel:
            return claim.Nugget.RouteFrom + " till " + claim.Nugget.RouteTo;
        case claimTypes.expense:
            return claim.Nugget.Purpose;
        case claimTypes.lostIncomeAmount:
        case claimTypes.lostIncomeNumber:
        case claimTypes.lostIncomeRate:
            return claim.Nugget.Employer;
        default:
            return null;
    }
}

class ProposedRemunerationController {
    static $inject = ['tromanServer', 'downloadService', 'dialogService'];
    /**
     * @param {ApiServer} tromanServer
     * @param {any} downloadService
     * @param {any} dialogService
     */
    constructor(tromanServer, downloadService, dialogService) {
        this._tromanServer = tromanServer;
        this._downloadService = downloadService;
        this._dialogService = dialogService;
        this.editRejection = false;

        /** @type {ProposedGroupModel} */
        this.paymentGroup = null;
        /** @type {Claim} */
        this.claim = null;
        /** @type {PaymentLock} */
        this.paymentLock = null;
    }

    get rejectionForm() {
        return this._rejectionForm;
    }

    // A little hackish, force rejection form to be default dirty
    set rejectionForm(value) {
        this._rejectionForm = value;
        if (value) {
            value.$setDirty();
        }
    }

    attachmentTitle(attachment) {
        return getAttachmentTypeName(attachment.AttachmentType);
    }

    $onChanges(changed) {
        if (changed.paymentGroup) {
            if (this.paymentGroup && this.paymentGroup.claim) {
                this.claim = this.paymentGroup.claim;
                
                const rejections = _.filter(this.claim.AuditEntries, x => x.Incident === auditIncidents.claimRejected);
                this.lastRejection = _.maxBy(rejections, x => x.Timestamp);

                this.title = getRemunerationTitle(remunerationTypes.claim, this.paymentGroup.claim.ClaimType);
                this.description = getClaimDescription(this.claim);
            } else {
                this.claim = null;
                this.title = null;
                this.description = null;
            }
        }
    }

    get isLocked() {
        return this.paymentLock.isLocked;
    }

    acceptClaim() {
        this.paymentGroup.accept();
    }

    rejectClaim() {
        this.paymentGroup.rejecting();
        this.paymentLock.lockGroup(this.paymentGroup);
    }

    confirmRejection() {
        this.paymentGroup.rejected();
        this.paymentLock.reset();
    }

    cancelRejection() {
        this.paymentGroup.reset();
        this.paymentLock.reset();
    }

    abortClaim() {
        this.paymentGroup.reset();
    }

    showDetails() {
        this._dialogService.showPaymentGroup(this.paymentGroup);
    }
    
    downloadAttachment(attachment) {
        this._tromanServer.Files.downloadAttachment(attachment.Id)
            .then(rsp => this._downloadService.downloadBlob(rsp.blob, rsp.filename));
    }

    employerChanged() {
        this.paymentGroup.recalculate();
    }
}

angular.module("tromanWeb").component('ergoProposedRemuneration', {
    template: require('./proposedRemuneration.html'),
    bindings: {
        paymentGroup: '<',
        paymentLock: '<',
        wageTypes: '<',
    },
    controller: ProposedRemunerationController,
});
